import type { VideoQualityConstraint } from './media.constants';

/**
 * Extracts numeric value from ConstrainDouble object using priority order of ideal > exact > min
 */
const extractConstraintValue = (
  constraint: number | ConstrainDouble | undefined,
): number | undefined => {
  if (!constraint) {
    return undefined;
  }

  if (typeof constraint === 'object') {
    return constraint.ideal ?? constraint.exact ?? constraint.min;
  }

  return constraint;
};

/**
 * Converts MediaTrackConstraints to VideoQualityConstraint by extracting numeric values
 * from ConstrainDouble objects using a priority order of ideal > exact > min
 */
export const convertToVideoQualityConstraint = (
  constraints?: MediaTrackConstraints,
): Partial<VideoQualityConstraint> => {
  if (!constraints) {
    return {};
  }

  const result: Partial<VideoQualityConstraint> = {};

  result.height = extractConstraintValue(constraints.height);
  result.width = extractConstraintValue(constraints.width);
  result.frameRate = extractConstraintValue(constraints.frameRate);

  return result;
};
